import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Eye, EyeOff, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // Redirect if already logged in
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin/analiticas');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      toast.success('¡Bienvenido!');
      navigate('/admin/analiticas');
    } else {
      toast.error(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-block transition-all duration-300 hover:opacity-90 hover:scale-105">
            <img
              src="https://customer-assets.emergentagent.com/job_4a150f39-c075-4c53-a862-1e5bef838f84/artifacts/lgkcbt00_image.png"
              alt="D'Avocado Swimwear"
              className="h-16 md:h-20 mx-auto mb-6 drop-shadow-lg"
            />
          </Link>
          <h1 className="text-2xl font-serif text-white mb-2">Panel de Administración</h1>
          <p className="text-white/60 text-sm">Ingresa tus credenciales para continuar</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-6 p-8 bg-[#0A0A0A] border border-white/10">
          <div>
            <label className="block text-white/60 text-sm mb-2">Email</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="bg-black border-white/20 text-white focus:border-gold"
              placeholder="admin@davocadoswimwear.com"
              data-testid="login-email"
            />
          </div>

          <div>
            <label className="block text-white/60 text-sm mb-2">Contraseña</label>
            <div className="relative">
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="bg-black border-white/20 text-white focus:border-gold pr-10"
                placeholder="••••••••"
                data-testid="login-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white"
              >
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full btn-gold-solid py-3"
            data-testid="login-submit"
          >
            {loading ? (
              <Loader2 className="w-5 h-5 animate-spin mx-auto" />
            ) : (
              'Iniciar Sesión'
            )}
          </Button>
        </form>

        {/* Back to Store */}
        <div className="mt-6 text-center">
          <Link to="/" className="text-white/40 hover:text-gold text-sm transition-colors">
            ← Volver a la Tienda
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
